import React from 'react'

import Stepper from '../../../../../../common/inputs/stepper/Stepper'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const NoBedrooms: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
}) => (
  <Stepper
    id='no-bedrooms'
    propertyName='noBedrooms'
    label='wizard.screen.otherFacilities.noBedrooms'
    input={insertionData.noBedrooms}
    type='tel'
    maxLength={3}
    max={99}
    errors={validationMessages!.noBedrooms ?? []}
    doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
  />
)

export default NoBedrooms
